<template>    
    <BaseModal
    :id="'static-update'"
    :title="title"
    :size="'lg'"
    :message="message"
    :disable_close="true">

    <template v-slot:breadcrumb>
        <Breadcrumb :breadcrumb="breadcrumb"/>
    </template>

    <template v-slot:content>
        <form class="row ml-0 mr-0 mb-0 mt-0" @submit.prevent="form_submit_update(single_object.id, global_index, undefined, [], single_object.permissions_action < 3 ? 'Associate permissions may take extra seconds to update.' : undefined)">
            <div class="col-12">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="false"
                />
                <label class="modal-label active mt-4"> {{countTotalPermissionsGiven}} out of {{ countTotalPermissions }} permissions given</label>
                <div class="overflow-auto ml-0 mr-0 mb-0 mt-2 shadow-sm p-3" style="max-height:35rem">
                    <div v-for="(item, i) in permissions"  :key="i"  class="row mb-0">
                        <b class="ml-1">{{ countPermissionsByModule(i)[0] + ' out of ' + countPermissionsByModule(i)[1] + ' permissions given' }}</b>
                        <div class="custom-control custom-checkbox d-block col-md-12 ml-2" >
                            <span>
                                <input :id="`theadcheck${item.module}`"  type="checkbox" class="custom-control-input ml-2" @change="selectAll(item, $event)" :ref="`theadcheck${item.module}`"/>
                                <label :for="`theadcheck${item.module}`" class="custom-control-label ml-2" v-html="'Check all'"/>
                            </span>
                            <span class="ml-3">
                                <input :id="`theadcheckWrite${item.module}`"  type="checkbox" class="custom-control-input" @change="selectAll(item, $event , 'write')" :ref="`theadcheckWrite${item.module}`"/>
                                <label :for="`theadcheckWrite${item.module}`" class="custom-control-label ml-4" v-html="'Check all Write'"/>
                            </span>
                            <span class="ml-3">
                                <input :id="`theadcheckRead${item.module}`"  type="checkbox" class="custom-control-input" @change="selectAll(item, $event, 'read')" :ref="`theadcheckRead${item.module}`"/>
                                <label :for="`theadcheckRead${item.module}`" class="custom-control-label ml-4" v-html="'Check all Read'"/>
                            </span>
                            <span class="ml-3">
                                <input :id="`theadcheckUpload${item.module}`"  type="checkbox" class="custom-control-input" @change="selectAll(item, $event, 'upload')" :ref="`theadcheckUpload${item.module}`"/>
                                <label :for="`theadcheckUpload${item.module}`" class="custom-control-label ml-4" v-html="'Check all Uploads'"/>
                            </span>
                        </div>
                        <div class="row associate-permissions ml-0 mr-0">
                            
                            <div class="col-md-2 col-sm-2 associate-permissions__module">
                                <span class="d-flex align-items-center justify-content-center">
                                    {{ item.module }}
                                </span>
                            </div>
                            <div class="col-md-10 col-sm-10 p-0">
                                <div class="row mb-0 ml-0 mr-0 mt-0" :class="item.module">
                                    <div class="col-md-4 col-sm-12 associate-permissions__group" v-for="group_permision in item.group_permissions" :key="group_permision.id">
                                        <div class="formdynamic__item__field associate-permissions__permission">
                                            <label v-html="`${group_permision.name}`" class="modal-label mb-2"/>
                                            <div class="px-0 col-md-12 p-0" v-for="(value, i) in group_permision.permissions" :key="i">
                                            <div class="custom-control custom-checkbox">
                                                <input :id="`${value.name}update`" type="checkbox" class="custom-control-input" :value="value.name" v-model="single_object.template_permissions"/>
                                                <label :for="`${value.name}update`" class="custom-control-label ml-2" v-html="value.alias" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-0 formdynamic__item col-md-12 shadow-none bg-light rounded" :style="`margin-top:15px`">
                    <div  id="1">
                        <div class="custom-control d-block py-1 px-2">
                            <input 
                                type="radio" 
                                class="custom-radio"
                                id="apply"
                                :value="1"
                                v-model="single_object.permissions_action"
                                :disabled="!hasPermissions(['Associate Permissions-Write'])"
                            />
                            <label
                            style="font-size: 0.9rem"
                            :class="'form-check-label radiobutton__text'" v-html="'Apply the permissions (given/removed) to associates linked to it'"
                                for="apply"
                            />
                        </div>
                        <div class="custom-control d-block py-1 px-2">
                            <input 
                                type="radio" 
                                class="custom-radio"
                                id="reset"
                                :value="2"
                                v-model="single_object.permissions_action"
                                :disabled="!hasPermissions(['Associate Permissions-Write'])"
                            />
                            <label
                            style="font-size: 0.9rem"
                            :class="'form-check-label radiobutton__text '" v-html="'Reset the permissions of the associates linked to it.'"
                                for="reset"
                            />
                        </div>
                        <div class="custom-control d-block py-1 px-2">
                            <input 
                                type="radio" 
                                class="custom-radio"
                                id="no-action"
                                :value="3"
                                v-model="single_object.permissions_action"
                            />
                            <label
                            style="font-size: 0.9rem"
                            :class="'form-check-label radiobutton__text '" v-html="'No action'"
                                for="no-action"
                            />
                        </div>
                    </div>
                </div>
                <CentralLiteButtons /> 
            </div>
        </form>
    </template>
    </BaseModal>
</template>

<script>

import FormDynamic      from    '@/components/FormDynamic.vue'
import BaseModal   from    '@/components/BaseModal'
import FormResources from   './form_resources'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import CentralLiteButtons from '@/components/CentralLiteButtons'
import { Notyf } from 'notyf'
import 'notyf/notyf.min.css'
const notyf = new Notyf({duration: 8000})

export default {

    name:   'UpdateModalTemplatePermissions',
    props: [
        'rest_api',
        'array_options',
        'breadcrumb',
        'permissions',
        'single_object',
        'global_index',
    ],

    components:{
        BaseModal,
        Breadcrumb,
        FormDynamic,
        CentralLiteButtons
    },

    data(){
        return{
            form_format: FormResources.form_format,
            message: `Here, you can easily allocate specific permissions to your templates to assign to associates. The permissions are conveniently grouped by their parent modules to streamline the assignment process.`,
            index: undefined,
            for_update: false,
            title: 'Associate Permissions',
            notyf,
            per: [] ,
            associate: {},
            is_loading: false,
        }
    },
    methods: 
    {
        reset()
        {
            this.permissions.forEach(item => {
                window.$(`#theadcheckWrite${item.module}`).prop('checked', false);
                window.$(`#theadcheckRead${item.module}`).prop('checked', false);
                window.$(`#theadcheckUpload${item.module}`).prop('checked', false);
            })
        },
        selectAll(item, event, type = null)
        {
            let is_checked = event.target.checked

            item.group_permissions.forEach(group_permission => 
            {
                let filter_permissions

                if(!type)
                {
                    filter_permissions = group_permission.permissions
                    window.$(`#theadcheckWrite${item.module}`).prop('checked', is_checked);
                    window.$(`#theadcheckRead${item.module}`).prop('checked', is_checked);
                    window.$(`#theadcheckUpload${item.module}`).prop('checked', is_checked);
                }
                else
                {
                    filter_permissions = group_permission.permissions.filter(item => item.name.toLowerCase().includes(type))
                }

                filter_permissions.forEach(permission => {

                    let index = this.single_object.template_permissions.findIndex(item => item == permission.name)
                    if(is_checked)
                    {
                        if(index == -1)
                        {
                            this.single_object.template_permissions.push(permission.name)
                        }
                    }
                    else
                    {
                        if(index > -1)
                        {
                            this.single_object.template_permissions.splice(index, 1)
                        }
                    }

                })
            })
        },
        countPermissionsByModule(index) 
        {
            let count = 0
            let count_given_permissions = 0;

            this.permissions[index].group_permissions.forEach(group_permission => 
            {
                count += group_permission.permissions.length

                group_permission.permissions.forEach(permission => {
                    let found_index = this.single_object.template_permissions.findIndex(associate_permission => associate_permission == permission.name)
                    if(found_index > -1)
                    {
                        count_given_permissions += 1
                    }
                })
            })

            return [count_given_permissions, count]
        }
    },

    computed: 
    {
        countTotalPermissions()
        {
            let count = 0
            this.permissions.forEach(permission => {
                permission.group_permissions.forEach(group_permission => {
                    count += group_permission.permissions.length
                })
            })
            return count
        },
        countTotalPermissionsGiven()
        {
            let count = 0
            this.permissions.forEach(permission => {
                permission.group_permissions.forEach(group_permission => {
                    group_permission.permissions.forEach(ind_permission => 
                    {
                        let found_index = this.single_object.template_permissions.findIndex(template_permission => template_permission == ind_permission.name)
                        if(found_index > -1)
                        {
                            console.log(ind_permission.group_permission_id);
                            count += 1
                        }
                    })
                })
            })
            return count
        }
    }
    
}
</script>